import { Typography } from "@mui/material";
import type { FacilityCampaignPublicResponse } from "@bw/shared/types/generated";
import { formatMoney, parseDecimal } from "@bw/shared/utils";

export function CampaignTerms({
  campaign,
  timezone,
}: {
  campaign: FacilityCampaignPublicResponse;
  timezone: string;
}) {
  const percentage = parseDecimal(campaign.discount_percent);
  const endsAt = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: timezone,
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  }).format(new Date(campaign.ends_at));
  return (
    <Typography
      component="span"
      variant="body2"
      color="text.secondary"
      sx={{ display: "block" }}
    >
      {campaign.discount_type === "fixed_amount"
        ? `${formatMoney(campaign.discount_amount, campaign.currency)} off`
        : `${percentage ?? "—"}% off`}{" "}
      {campaign.audience === "new_to_facility"
        ? "your first paid court booking"
        : `a paid court booking (${campaign.per_player_limit} use${campaign.per_player_limit === 1 ? "" : "s"} per player)`}
      {campaign.maximum_discount != null
        ? `, up to ${formatMoney(campaign.maximum_discount, campaign.currency)}`
        : ""}
      .
      {campaign.minimum_cart_amount != null
        ? ` Minimum court subtotal ${formatMoney(campaign.minimum_cart_amount, campaign.currency)}.`
        : ""}
      {` Ends ${endsAt}.`}
    </Typography>
  );
}
